import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { Property } from '../models/property';
import { PropertyAddComponent } from '../property-add/property-add.component';
import { PopupType } from '../models/property-popup-type.enum';
import { PropertySearchComponent } from '../property-search/property-search.component';

@Component({
  selector: 'pioneer-property-popup',
  templateUrl: './property-popup.component.html'
})
export class PropertyPopupComponent implements OnInit {

  propertyPopupType = PopupType.SEARCH;

  PopupType = PopupType;

  @ViewChild(ModalDirective)
  propertyModal: ModalDirective;

  @ViewChild(PropertySearchComponent)
  propertySearch: PropertySearchComponent;

  @ViewChild(PropertyAddComponent)
  propertyAdd: PropertyAddComponent;

  config = {
    backdrop: 'static',
    keyboard: false
  };

  @Output()
  closed = new EventEmitter<Property>();

  constructor() { }

  ngOnInit() {
  }

  open(): void {
    this.propertyPopupType = PopupType.SEARCH;
    this.propertyModal.show();
  }

  goToAdd(): void {
    this.propertyPopupType = PopupType.ADD;
  }

  cancelSearch(): void {
    this.close(null);
  }

  selectProperty(propertySelected: Property) {
    if (this.propertyAdd) {
      this.propertyAdd.reset();
    }
    this.propertySearch.reset();
    this.close(propertySelected);
  }

  acceptAdd(savedProperty: Property): void {
    if (this.propertyAdd) {
      this.propertyAdd.reset();
      savedProperty.manuallyAdded = true;
    }
    this.propertySearch.reset();
    this.close(savedProperty);
  }

  cancelAdd(): void {
    this.propertyPopupType = PopupType.SEARCH;
  }

  private close(value: Property): void {
    this.closed.emit(value);
    this.propertyModal.hide();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/property-popup/property-popup.component.ts